import {
  SIGNUP_USER,
  SIGNIN_USER,
  PASSWORD_CHANGE,
  SIGNOUT_USER,
  GET_CURRENT_USER,
  CLEAR_MESSAGE
} from "../../Constants/ActionTypes"

export function userSignUp(user) {
  return { type: SIGNUP_USER, payload: user }
}

export function userSignIn(user) {
  return { type: SIGNIN_USER, payload: user }
}

export function userSignOut(user) {
  return { type: SIGNOUT_USER, payload: user }
}

export function changePassword(data) {
  return { type: PASSWORD_CHANGE, payload: data }
}

export function getCurrentUser(token) {
  return { type: GET_CURRENT_USER, payload: token }
}

export function clearMessage() {
  return { type: CLEAR_MESSAGE }
}

// export function getCurrentUser(token) {
//   return {type: GET_CURRENT_USER, payload: token}
// }